export const FIND_REPORT_FAILURE = 'FIND_REPORT_FAILURE';

export const findReportFailure = error => ({
    type: FIND_REPORT_FAILURE,
    payload: error,
    error: true,
});
